export const GET_CLIENT_REQUEST = 'GET_CLIENT_REQUEST';
export const GET_CLIENTS_REQUEST = 'GET_CLIENTS_REQUEST';
export const GET_CLIENT_BILLING_ENTITIES_REQUEST = 'GET_CLIENT_BILLING_ENTITIES_REQUEST';
export const GET_CLIENT_ACCOUNTS_REQUEST = 'GET_CLIENT_ACCOUNTS_REQUEST';
export const SET_CLIENTS_DATA = 'SET_CLIENTS_DATA';
export const CREATE_CLIENT_REQUEST = 'CREATE_CLIENT_REQUEST';
export const UPDATE_CLIENT_REQUEST = 'UPDATE_CLIENT_REQUEST';
export const GET_CLIENT_FIXED_PRICE_RATES_REQUEST = 'GET_CLIENT_FIXED_PRICE_RATES_REQUEST';
export const SET_CLIENT_FIXED_PRICE_RATE_REQUEST = 'SET_CLIENT_FIXED_PRICE_RATE_REQUEST';
export const ACTIVATE_CLIENT_REQUEST = 'ACTIVATE_CLIENT_REQUEST';
export const DEACTIVATE_CLIENT_REQUEST = 'DEACTIVATE_CLIENT_REQUEST';
export const DELETE_CLIENT_REQUEST = 'DELETE_CLIENT_REQUEST';
export const RESTORE_CLIENT_REQUEST = 'RESTORE_CLIENT_REQUEST';
export const GET_UNBILLED_CHARGES_REQUEST = 'GET_UNBILLED_CHARGES_REQUEST';
export const ADD_CLIENT_DOCUMENT_REQUEST = 'ADD_CLIENT_DOCUMENT_REQUEST';
export const UPDATE_CLIENT_DOCUMENT_REQUEST = 'UPDATE_CLIENT_DOCUMENT_REQUEST';
export const DELETE_CLIENT_DOCUMENT_REQUEST = 'DELETE_CLIENT_DOCUMENT_REQUEST';
export const REQUEST_CLIENT_DOCUMENT_COPY_REQUEST = 'REQUEST_CLIENT_DOCUMENT_COPY_REQUEST';
export const GET_CLIENT_DOCUMENTS_REQUEST = 'GET_CLIENT_DOCUMENTS_REQUEST';
export const GET_CLIENT_DOCUMENT_SCOPES_REQUEST = 'GET_CLIENT_DOCUMENT_SCOPES_REQUEST';
export const GET_CLIENT_DOCUMENT_TYPES_REQUEST = 'GET_CLIENT_DOCUMENT_TYPES_REQUEST';
export const ADD_CLIENT_DOCUMENT_CHANGE_REQUEST = 'ADD_CLIENT_DOCUMENT_CHANGE_REQUEST';
export const UPDATE_CLIENT_DOCUMENT_CHANGE_REQUEST = 'UPDATE_CLIENT_DOCUMENT_CHANGE_REQUEST';
export const DELETE_CLIENT_DOCUMENT_CHANGE_REQUEST = 'DELETE_CLIENT_DOCUMENT_CHANGE_REQUEST';
export const CONTACT_CLIENT_REQUEST = 'CONTACT_CLIENT_REQUEST';

export const getClient = (clientId, callback) => ({
    type: GET_CLIENT_REQUEST,
    payload: { clientId, callback }
});

export const getClients = (start, limit, onSuccess, options) => ({
    type: GET_CLIENTS_REQUEST,
    payload: { start, limit, onSuccess, options },
});

export const getClientBillingEntities = (callback) => ({
    type: GET_CLIENT_BILLING_ENTITIES_REQUEST,
    payload: { callback },
});

export const getClientAccounts = (clientId, onSuccess) => ({
    type: GET_CLIENT_ACCOUNTS_REQUEST,
    payload: { clientId, onSuccess },
});

export const setClientsData = (clients) => ({
    type: SET_CLIENTS_DATA,
    payload: clients,
});

export const createClient = (client, callback) => ({
    type: CREATE_CLIENT_REQUEST,
    payload: { client, callback }
});

export const updateClient = (clientId, updates, callback) => ({
    type: UPDATE_CLIENT_REQUEST,
    payload: { clientId, updates, callback }
});

export const activateClient = (clientId, callback) => ({
    type: ACTIVATE_CLIENT_REQUEST,
    payload: { clientId, callback }
});

export const deactivateClient = (clientId, callback) => ({
    type: DEACTIVATE_CLIENT_REQUEST,
    payload: { clientId, callback }
});

export const deleteClient = (clientId, callback) => ({
    type: DELETE_CLIENT_REQUEST,
    payload: { clientId, callback }
});

export const restoreClient = (clientId, callback) => ({
    type: RESTORE_CLIENT_REQUEST,
    payload: { clientId, callback }
});

export const getUnbilledCharges = (clientId, callback) => ({
    type: GET_UNBILLED_CHARGES_REQUEST,
    payload: { clientId, callback }
});

export const addClientDocument = (clientId, document, callback) => ({
    type: ADD_CLIENT_DOCUMENT_REQUEST,
    payload: { clientId, document, callback }
});

export const updateClientDocument = (clientId, docId, updates, callback) => ({
    type: UPDATE_CLIENT_DOCUMENT_REQUEST,
    payload: { clientId, docId, updates, callback }
});

export const deleteClientDocument = (clientId, docId, callback) => ({
    type: DELETE_CLIENT_DOCUMENT_REQUEST,
    payload: { clientId, docId, callback }
});

export const requestClientDocumentCopy = (clientId, docId, callback) => ({
    type: REQUEST_CLIENT_DOCUMENT_COPY_REQUEST,
    payload: { clientId, docId, callback }
});

export const getClientDocuments = (params, callback) => ({
    type: GET_CLIENT_DOCUMENTS_REQUEST,
    payload: { params, callback }
});

export const getClientDocumentScopes = (clientId, search, callback) => ({
    type: GET_CLIENT_DOCUMENT_SCOPES_REQUEST,
    payload: { clientId, search, callback }
});

export const getClientDocumentTypes = (callback) => ({
    type: GET_CLIENT_DOCUMENT_TYPES_REQUEST,
    payload: { callback }
});

export const addClientDocumentChange = (clientId, docId, change, callback) => ({
    type: ADD_CLIENT_DOCUMENT_CHANGE_REQUEST,
    payload: { clientId, docId, change, callback }
});

export const updateClientDocumentChange = (clientId, docId, changeId, updates, callback) => ({
    type: UPDATE_CLIENT_DOCUMENT_CHANGE_REQUEST,
    payload: { clientId, docId, changeId, updates, callback }
});

export const deleteClientDocumentChange = (clientId, docId, changeId, callback) => ({
    type: DELETE_CLIENT_DOCUMENT_CHANGE_REQUEST,
    payload: { clientId, docId, changeId, callback }
});

export const contactClient = (clientId, payload, callback) => ({
    type: CONTACT_CLIENT_REQUEST,
    payload: { clientId, data: payload, callback },
});

export const getClientFixedPriceRates = (callback) => ({
    type: GET_CLIENT_FIXED_PRICE_RATES_REQUEST,
    payload: { callback }
});

export const setClientFixedPriceRate = (clientId, fixedPriceRate, callback) => ({
    type: SET_CLIENT_FIXED_PRICE_RATE_REQUEST,
    payload: { clientId, fixedPriceRate, callback }
});
